export var StorageType = {};
StorageType.MEMORY = 0;
StorageType.IMMUTABLE_MEMORY = 1;
StorageType.SESSION = 2;
StorageType.LOCAL = 3;
StorageType[StorageType.MEMORY] = "MEMORY";
StorageType[StorageType.IMMUTABLE_MEMORY] = "IMMUTABLE_MEMORY";
StorageType[StorageType.SESSION] = "SESSION";
StorageType[StorageType.LOCAL] = "LOCAL";
//# sourceMappingURL=persistence.storage_type.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/angular-persistence/src/constants/persistence.storage_type.js
// module id = 114
// module chunks = 3